import React from "react";
import './Delivery.css'
import DeliveryAgregarIzquierda from "./AgregarIzquierda";
import DeliveryAgregarDerecha from "./AgregarDerecha";

class DeliveryAgregar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            productos: [
                {
                    id: 1,
                    nombre: "Pollo sin papas",
                    presentacion: "Entero",
                    precio: 50,
                    cantidad: 20,
                },
                {
                    id: 3,
                    nombre: "Parrilla de Res pura cremas",
                    presentacion: "Octavo",
                    precio: 50,
                    cantidad: 15,
                },
                {
                    id: 4,
                    nombre: "Lomo de Pollo sin Carne",
                    presentacion: "Cuarto",
                    precio: 50,
                    cantidad: 40,
                },
                                {
                    id: 5,
                    nombre: "Pollo sin papas",
                    presentacion: "Entero",
                    precio: 50,
                    cantidad: 20,
                },
                {
                    id: 6,
                    nombre: "Parrilla de Res pura cremas",
                    presentacion: "Octavo",
                    precio: 50,
                    cantidad: 15,
                },
                {
                    id: 7,
                    nombre: "Lomo de Pollo sin Carne",
                    presentacion: "Cuarto",
                    precio: 50,
                    cantidad: 40,
                },
                {
                    id: 8,
                    nombre: "Lomo de Pollo sin Carne",
                    presentacion: "Cuarto",
                    precio: 50,
                    cantidad: 40,
                },
                                {
                    id: 9,
                    nombre: "Pollo sin papas",
                    presentacion: "Entero",
                    precio: 50,
                    cantidad: 20,
                },
                {
                    id: 10,
                    nombre: "Parrilla de Res pura cremas",
                    presentacion: "Octavo",
                    precio: 50,
                    cantidad: 15,
                },
                {
                    id: 11,
                    nombre: "Lomo de Pollo sin Carne",
                    presentacion: "Cuarto",
                    precio: 50,
                    cantidad: 40,
                },
            ],
            Documento: "999999999",
            loading: true,
            dataCliente: [
                {
                    IdCliente:1,
                    RazonSocial: "Abed Nego Llovera Llanos",
                    NumeroDoc: "71908695",
                    celular: "971435299",
                    Direcciones: [
                        {
                            IdDireccion: 1,
                            Direccion: "Jr. San Salvador 520",
                            Referencia: "A media cuadra de iglesa Mormones"
                        },
                        {
                            IdDireccion: 2,
                            Direccion: "Jr. San Pedro 520",
                            Referencia: "A media cuadra de iglesa San Pedro"
                        }
                    ],
                },
                {
                    IdCliente:2,
                    RazonSocial: "Elizabeth Alejandra Rojas Honores",
                    NumeroDoc: "99999998",
                    celular: "999999998",
                    Direcciones: [
                        {
                            IdDireccion: 1,
                            Direccion: "Jr. San Salvador 520",
                            Referencia: "A media cuadra de iglesa Mormones"
                        },
                        {
                            IdDireccion: 2,
                            Direccion: "Jr. San Pedro 520",
                            Referencia: "A media cuadra de iglesa San Pedro"
                        }
                    ],
                },
                {
                    IdCliente:3,
                    RazonSocial: "Felicita Viviana Carmona Salazar",
                    NumeroDoc: "99999997",
                    celular: "999999997",
                    Direcciones: [
                        {
                            IdDireccion: 1,
                            Direccion: "Jr. San Salvador 520",
                            Referencia: "A media cuadra de iglesa Mormones"
                        },
                        {
                            IdDireccion: 2,
                            Direccion: "Jr. San Pedro 520",
                            Referencia: "A media cuadra de iglesa San Pedro"
                        }
                    ],
                }
            ],
            buscar: "",
            carrito: [],
            total: 0

        }
    }

    agregarAlCarrito = (producto) => {
        const existeEnCarrito = this.state.carrito.find(item => item.id === producto.id);
        
        if (existeEnCarrito) {
            const carritoActualizado = this.state.carrito.map(item =>
                item.id === producto.id
                    ? { ...item, cantidad: item.cantidad + 1 }
                    : item
            );
            this.setState({ 
                carrito: carritoActualizado 
            }, this.calcularTotal);
        } else {
            this.setState({ 
                carrito: [...this.state.carrito, { ...producto, cantidad: 1 }] 
            }, this.calcularTotal);
        }
    }

    calcularTotal = () => {
        const total = this.state.carrito.reduce((acc, item) => {
            return acc + (item.precio * item.cantidad);
        }, 0);
        this.setState({ total });
    }

    handlePagar = () => {
        alert(`Procesando pago por S/. ${this.state.total.toFixed(2)}`);
    }

    handleClickNuevo = () => {
        this.setState({
            modalClienteIsOpen: true,
            itemcliente: {
                ...this.state.itemcliente,
                idcliente: null,
            }
        })
    }

    handleChange = (e) => {
        this.setState({ buscar: e.target.value });
    }

    handleEnterKeyUp = (e) => {
        if (e.key === 'Enter') {
            console.log('Buscar producto:', this.state.buscar);
        }
    }

    TraerClientePorDoc = async (DNI) => {
        try {
            await fetch(`/api/preVentas/traerCliente/${DNI}`)
                .then(res => res.json())
                .then(async data => {
                    this.setState({
                        loading: false,
                        dataCliente: data[0] ? data[0] : 0,
                        IdCliente: data[0] ? data[0].IdCliente : 0,
                        StockPorCliente: []
                    });
                });
        } catch (error) {
            this.setState({
                loading: false,
                error: error,
            });
        }
    }
    

    render(){
        return(
            <React.Fragment>
                <div className="preventa__container">
                    <div className="preventa row h-100">
                        <DeliveryAgregarIzquierda
                            productos={this.state.productos}
                            Documento={this.state.Documento}
                            dataCliente={this.state.dataCliente}
                            buscar={this.state.buscar}
                            handleClickNuevo={this.handleClickNuevo}
                            handleChange={this.handleChange}
                            handleEnterKeyUp={this.handleEnterKeyUp}
                            TraerClientePorDoc={this.TraerClientePorDoc}
                            agregarAlCarrito={this.agregarAlCarrito}
                        />
                        <DeliveryAgregarDerecha
                            productos={this.state.productos}
                            carrito={this.state.carrito}
                            calcularTotal={this.calcularTotal}
                        />
                    </div>
                    <footer className="abed__footer2">
                        <div className="abed__total-container2">
                        </div>
                        <div className="abed__total-container2">
                            <h2 className="abed__total2">TOTAL A PAGAR:</h2>
                            <h2 className="abed__precio-total2">S/. {this.state.total.toFixed(2)}</h2>
                        </div>
                        <div className="totals__container--item">
                            <button 
                                className="abed__generar__boton btn boton-generar-resp letra-total"
                                onClick={this.handlePagar}
                                disabled={this.state.total === 0}
                            >
                                Generar
                            </button>
                        </div>

                    </footer>
                </div>
            </React.Fragment>
        )
    }
}

export default DeliveryAgregar;